<template>
    <div>
        <label for="bankName">Bank / Building Society name</label>
        <input
            type="text"
            id="bankName" ref="bankName"
            fieldlabel="Bank / Building Society"
            class="form-control form-control-lg"
            v-model="bankobject.name"
            v-taurus-validator="'min:3|required'">
        <div name="bankName"></div>
        <!-- <div
            v-if="$v.bankName.$dirty && $v.bankName.$error"
            class="text-danger">
            <small>Please enter the name of the Bank / Building Society</small>
        </div> -->

        <label for="accountName">Account name</label>
        <input
            type="text"
            id="accountName" ref="accountName"
            fieldlabel="Account name"
            class="form-control form-control-lg"
            v-model="bankobject.accountName"
            v-taurus-validator="'min:5|required'">
        <div name="accountName"></div>
        <!-- <div
            v-if="$v.accountName.$dirty && $v.accountName.$error"
            class="text-danger">
            <small>Please enter the name of account holder</small>
        </div> -->

        <label for="accountNumber">Account number</label>
        <input
            type="text"
            id="accountNumber" ref="accountNumber"
            fieldlabel="Account number"
            class="form-control form-control-lg"
            v-model="bankobject.accountNumber"
            v-taurus-validator="'required|numeric|max:8'">
        <div name="accountNumber"></div>
        <!-- <div
            v-if="$v.accountNumber.$dirty && $v.accountNumber.$error"
            class="text-danger">
            <small>Please enter the account number</small>
        </div> -->

        <label for="accountSortcode">Sort code</label>
        <input
            type="text"
            id="accountSortcode" ref="accountSortcode"
            fieldlabel="Sort code"
            class="form-control form-control-lg"
            v-model="bankobject.accountSortcode"
            v-taurus-validator="'required|numeric|max:6'">
        <div name="accountSortcode"></div>
        <!-- <div
            v-if="$v.accountSortcode.$dirty && $v.accountSortcode.$error"
            class="text-danger">
            <small>Please enter the account sort code</small>
        </div> -->

    </div>
</template>

<script>
export default {
  name: 'bankDetails',
  props: {
    value: { required: true }
  },
  data () {
    return {
      bankobject: {
        name: "",
        accountName: "",
        accountNumber: "",
        accountSortcode: ""
      }
    }
  },
  mounted () {
    if (this.value) {
      this.bankobject.name = this.value.name
      this.bankobject.accountName = this.value.accountName
      this.bankobject.accountNumber = this.value.accountNumber
      this.bankobject.accountSortcode = this.value.accountSortcode
    }
  },
  methods: {
  },
  watch: {
    bankobject: {
      handler() {    
        this.$emit('input', this.bankobject);
        let test = !this.$validator.some(e => e.valid === false);
        this.$emit("isValid", test);       
      },
      deep: true
    }
  }
}

</script>
